import {
  IAssignableExpression,
  IBaseWidget,
  IConditionGroupExpression,
  IInputWidget,
  WidgetType,
} from '@framework/engine';

export interface IModuleTriggerWidget extends IInputWidget {
  type: WidgetType.ModuleTrigger;

  /**
   * Identificativo modulo da attivare
   */
  moduleId: string;

  /**
   * Condizione di attivazione
   */
  expression: IConditionGroupExpression;

  needUniqueModuleCode: boolean;

  /**
   * Codice univoco di attivazione. Se più attivatori utilizzano lo stesso
   * codice univoco, verrà attivato un unico modulo.
   */
  uniqueModuleCode: IAssignableExpression | null | undefined;

  /**
   * Titolo da fornire al modulo per permettere all'utente di identificarlo.
   */
  title: IAssignableExpression | null | undefined;
}

export const WidgetModuleTriggerType =
  'moduleTrigger' as WidgetType.ModuleTrigger;

export function isModuleTriggerWidget(
  w: IBaseWidget,
): w is IModuleTriggerWidget {
  return w.type === WidgetModuleTriggerType;
}
